// @ts-nocheck
/**
 * StatusBanners - Displays status banners (COPPA warning, loading, errors)
 * Extracted from App.tsx for modularization
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

interface StatusBannersProps {
  coppaBlocked: boolean;
  isProfileLoading: boolean;
  profileError: string | null;
  language: string;
}

export default function StatusBanners({ 
  coppaBlocked, 
  isProfileLoading, 
  profileError, 
  language 
}: StatusBannersProps) {
  const { t } = useTranslation('common');

  return (
    <div className="banner-container" style={{ minHeight: '0px' }}>
      {coppaBlocked && (
        <div className="banner banner--warning">
          {t('warnings.coppaBlocked')}
        </div>
      )}
      {profileError && <div className="banner banner--error">{profileError}</div>}
    </div>
  );
}
